export default __webpack_public_path__ + "static/media/18.46e0161a.jpg";